/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Stopnie skali PMC. Nizsza ocena jest lepsza: SCORE_1 to znacznie powyzej oczekiwanych zachowan, SCORE_5 to znacznie ponizej. Wpisy, ktorych nie da sie odczytac jako oceny ze skali, nie trafiaja do zadnego slupka ani do sredniej. 
 * @export
 * @enum {string}
 */

export const PmcScoreDto = {
    Score1: 'SCORE_1',
    Score2: 'SCORE_2',
    Score3: 'SCORE_3',
    Score4: 'SCORE_4',
    Score5: 'SCORE_5'
} as const;

export type PmcScoreDto = typeof PmcScoreDto[keyof typeof PmcScoreDto];



